


/**
 * DelayManager class
 */
export class DelayManager {
    private callback: Function = () => { };
    private time: number = 0;
    private timer!: NodeJS.Timeout;

    constructor(callback: Function, time: number = 1000) {
        this.callback = callback;
        this.time = time;
        this.init();
    }

    init = () => {
        this.timer = setTimeout(() => {
            this.callback();
        }, this.time);
    }

    destroy = () => {
        clearTimeout(this.timer);
    }

}